<template>
  <div class="homepage-cta">
    <div class="container">
      <el-row>
        <grid-col
          :xs="{ span: 20, offset: 2 }"
          :sm="{ span: 15, offset: 5}"
          :md="{ span: 12, offset: 2 }"
          :lg="{ span: 12, offset: 3 }"
          :xl="{ span: 12, offset: 2 }">
          <div>
            <h1 class="title">Listen wherever you are.</h1>
            <p class="subtitle">Download the app and start listening to the full collection of Luminary Originals. Available on iOS, Android, and Alexa.</p>
          </div>
          <div>
            <app-store-links
              :homepage-display="true"/>
          </div>
        </grid-col>
        <grid-col
          :xs="{ span: 24, offset: 2 }"
          :sm="{ span: 22, offset: 6 }"
          :md="{ span: 8, offset: 2 }"
          :lg="{ span: 8, offset: 1 }"
          :xl="{ span: 8, offset: 1 }">
          <div class="homepage-cta__device">
            <img
              src="../../../assets/images/phoneAlexaHomepage.png"
              alt="">
          </div>
        </grid-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import AppStoreLinks from '../../AppStoreLinks';

export default {
  name: 'Insta',
  components: {
    'app-store-links': AppStoreLinks,
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";

.homepage-cta {
  background: #121C30;
  padding: 45px 0 28px;
  background: linear-gradient(180deg, #1B263C 0%, #010D25 78.12%, #1B263C 89.58%);
  .title {
    color: $white;
    font-family: $serif;
    font-size: 36px;
    line-height: 47px;
    text-align: center;
    font-weight: 500;
    @media (min-width: $xs) {
      max-width: initial;
      font-size: 36px;
      line-height: 42px;
      padding-top: 60px;
    }
    @media (min-width: $sm) {
      max-width: initial;
      font-size: 36px;
      line-height: 42px;
      padding-top: 20px;
      text-align: left;
    }
    @media (min-width: $md) {
      font-size: 48px;
      line-height: 48px;
      padding-top:20px;
      text-align: left;
    }
    @media (min-width: $lg) {
      font-size: 48px;
      line-height: 56px;
      padding-top:20px;

    }
  }

  .subtitle {
    color: $white;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 36px;
    text-align: center;
    @media (min-width: $xs) {
      max-width: initial;
    }
    @media (min-width: $sm) {
      max-width: 428px;
      text-align: left;
    }
    @media (min-width: $md) {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 48px;
    }
  }

  &__device {
      display: block;
      height: 280px;
      width: 280px;
      margin-top: 30px;
      margin-left: auto;
      margin-right: auto;
      @media (min-width: $xs) {
        margin-left: 0px;
      }
      @media (min-width: $sm) {
        height: 300px;
        width: 300px;
        margin-top: 0px;
        margin-left:0px;
      }
      @media (min-width: $md) {
        height: 400px;
        width: 400px;
      }
    img {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
